import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'

interface TriggerRequestProps<T> {
  queryKey: string | string[]
  endpoint: string
  options?: {
    enabled?: boolean
    onSuccess?: (data: T | any) => void
    onError?: (error: Error) => void
    onSettled?: () => void
    onInit?: () => void
  }
}

export function useTriggerRequest<T>({ queryKey, endpoint, options }: TriggerRequestProps<T>) {
  const { getAccessTokenSilently } = useAuth0()

  const triggerRequest = async () => {
    if (options?.onInit) {
      options.onInit()
    }

    const accessToken = await getAccessTokenSilently()
    const response = await fetch(endpoint, { headers: { Authorization: `Bearer ${accessToken}` } })

    if (!response.ok) {
      throw new Error('An error occurred while fetching data')
    }

    return response.json()
  }

  const query = useQuery({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
    queryFn: triggerRequest,
    ...options,
  })

  return query
}
